export default function Input({
    label,
    name,
    type = "text",
    value,
    onChange,
    placeholder = "",
    error = "",
    required = false,
    className = "",
    multiline = false,
    rows = 3,
    disabled = false,
}) {
    const baseStyles =
        "w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 transition-colors";

    const activeStyles = error
        ? "border-primary focus:ring-primary"
        : "border-surface focus:ring-primary";

    return (
        <div className={`space-y-1 ${className}`}>
            {label && (
                <label
                    htmlFor={name}
                    className="block text-medium mb-1"
                >
                    {label} {required && <span className="text-primary">*</span>}
                </label>
            )}

            {multiline ? (
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    rows={rows}
                    disabled={disabled}
                    className={`${baseStyles} ${activeStyles} ${disabled ? "bg-surface cursor-not-allowed" : ""}`}
                />
            ) : (
                <input
                    id={name}
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={`${baseStyles} ${activeStyles} ${disabled ? "bg-surface cursor-not-allowed" : ""}`}
                />
            )}

            {error && (
                <p className="text-red-500 text-sm mt-1">{error}</p>
            )}
        </div>
    );
}
